export const BREAK_POINT_MOBILE = 768;
export const BREAK_POINT_TABLET = 992;
export const BREAK_POINT_PC = 1200;
